import { defineMessages } from 'react-intl'

export const emailFieldMessages = defineMessages({
  placeholder: {
    id: 'emailField.placeholder',
    description: 'Default placeholder for Email input',
    defaultMessage: 'Email',
  },
})
